import type { FC } from 'react'

import styled from '@emotion/styled'

import * as HeroRecipe from '@segment/matcha/recipes/Hero'

import HeroPng2x from './assets/Hero@2x.png'
import HeroWebp from './assets/Hero.webp'
import HeroWebp2x from './assets/Hero@2x.webp'

const SIZES = `(max-width: 600px) 540px, 1080px`

const HeroImage: FC = () => {
  return (
    <Wrapper>
      <StyledPicture>
        <source
          width="540"
          height="540"
          type="image/webp"
          srcSet={`${HeroWebp} 540w, ${HeroWebp2x} 1080w`}
          sizes={SIZES}
        />
        <HeroRecipe.Image width="540" height="540" src={HeroPng2x} sizes={SIZES} alt="Events Image" />
      </StyledPicture>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
  height: 0;
  padding-top: 100%;
  position: relative;
`

const StyledPicture = styled.picture`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
`

export default HeroImage
